import { unref } from 'vue'
export const deepUnref = (
  obj: any[] | Record<string, any>
): any[] | Record<string, any> => {
  const currentObj: any[] | Record<string, any> = unref(obj)
  for (const i in obj) {
    currentObj[i] = unref(obj[i])
    if (typeof obj[i] === 'object') {
      currentObj[i] = deepUnref(obj[i])
    }
  }
  return currentObj
}
